module.exports = __webpack_public_path__ + "img/1000m.380f83a2.png";